import { RESET_GAME_PROGRESS_REQUEST } from "../../shared/constants";

/**
 * Action to reset progress for user for new themes middle/primary school
 */
export const resetProgress = () => ({
  type: RESET_GAME_PROGRESS_REQUEST,
});
